// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:27
import { TransferFile_abstract } from './../../abstract/SagaBase/Objects/TransferFile_abstract';
export class TransferFile extends TransferFile_abstract {}
